import React, { useEffect, useState } from "react";
import {
  collection,
  onSnapshot,
  orderBy,
  query,
  where,
  limit,
} from "firebase/firestore";
import { db } from "../../firebase";
import GroupNoteContainer from "../Notes/GroupNoteContainer";
import { CircularProgress } from "@mui/material";

function GroupNotesByClient({ clientId }) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clientId) return;
    const notesRef = collection(db, "notes");
    const q = query(
      notesRef,
      where("noteType", "==", "groupNote"),
      where("attendees", "array-contains", clientId),
      orderBy("effectiveDateTime", "desc"),
      limit(50)
    );

    const unsub = onSnapshot(q, (snap) => {
      const arr = [];
      snap.forEach((doc) => arr.push({ id: doc.id, ...doc.data() }));
      setNotes(arr);
      setLoading(false);
    });

    return () => unsub();
  }, [clientId]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "16px" }}>
        <CircularProgress size={28} />
        <div style={{ marginTop: 8 }}>Loading group notes…</div>
      </div>
    );
  }

  if (!notes.length) {
    return (
      <div
        style={{
          padding: "16px",
          marginTop: "8px",
          border: "1px dashed #c5c5c5",
          borderRadius: "8px",
          color: "#555",
          background: "#fafafa",
          textAlign: "center",
        }}
      >
        No group notes for this client yet.
      </div>
    );
  }

  return (
    <div className="notes-container-global">
      {notes.map((note) => {
        const dateOptions = { day: "numeric", month: "short", year: "numeric" };
        const timeOptions = { hour: "2-digit", minute: "2-digit" };
        const tsOptions = {
          ...dateOptions,
          hour: "2-digit",
          minute: "2-digit",
        };

        const formattedDate = note.effectiveDateTime
          ? new Intl.DateTimeFormat("en-EN", dateOptions).format(
              note.effectiveDateTime.toDate()
            )
          : "";
        const formattedTime = note.effectiveDateTime
          ? new Intl.DateTimeFormat("en-EN", timeOptions).format(
              note.effectiveDateTime.toDate()
            )
          : "";
        const formattedTimestamp = note.createdAt
          ? new Intl.DateTimeFormat("en-EN", tsOptions).format(
              note.createdAt.toDate()
            )
          : "";
        const formattedLastModification = note.updateAt
          ? new Intl.DateTimeFormat("en-EN", tsOptions).format(
              note.updateAt.toDate()
            )
          : "";

        return (
          <div key={note.id} style={{ paddingBottom: "15px" }}>
            <GroupNoteContainer
              noteContent={note.noteContent}
              effectiveDateTime={note.effectiveDateTime}
              noteDate={formattedDate}
              noteTime={formattedTime}
              doneBy={note.doneBy}
              timeStamp={formattedTimestamp}
              lastModification={formattedLastModification}
              noteId={note.id}
              groupTopic={note.groupTopic}
              groupType={note.typeGroupNote}
              otherTypeGroupNote={note.otherTypeGroupNote}
              notInAttendance={note.notInAttendance}
              updateAt={note.updateAt}
              createdAt={note.createdAt}
              groupStartDateTime={note.groupStartDateTime}
              attendees={note.attendees}
              attendeesDetails={note.attendeesDetails}
              {...note}
            />
          </div>
        );
      })}
    </div>
  );
}

export default GroupNotesByClient;
